import { render } from "./BackgroundTasksView.vue?vue&type=template&id=3953cd15&scoped=true"
import script from "./BackgroundTasksView.vue?vue&type=script&lang=js"
export * from "./BackgroundTasksView.vue?vue&type=script&lang=js"

import "./BackgroundTasksView.vue?vue&type=style&index=0&id=3953cd15&scoped=true&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3953cd15"]])

export default __exports__